/* tslint:disable */

declare var Object: any;
export interface InvitationMemberInterface {
  "id"?: number;
}

export class InvitationMember implements InvitationMemberInterface {
  "id": number;
  constructor(data?: InvitationMemberInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `InvitationMember`.
   */
  public static getModelName() {
    return "InvitationMember";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of InvitationMember for dynamic purposes.
  **/
  public static factory(data: InvitationMemberInterface): InvitationMember{
    return new InvitationMember(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'InvitationMember',
      plural: 'InvitationMembers',
      path: 'InvitationMembers',
      idName: 'id',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/sdk/models/InvitationMember.ts